export function isValidTime(time: string): boolean {
    // Regular expression to match HH:MM format
    const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
    return timePattern.test(time);
}

export function isGreaterThanTime(time: string, compareTime: string): boolean {
    const [hours, minutes] = time.split(':').map(Number);
    const [compareHours, compareMinutes] = compareTime.split(':').map(Number);

    // Check if the time is valid
    if (isNaN(hours) || isNaN(minutes) || isNaN(compareHours) || isNaN(compareMinutes)) {
        return false; // Invalid time
    }

    // Compare times
    if (hours > compareHours || (hours === compareHours && minutes > compareMinutes)) {
        return true;
    }
    return false;
}